<template>
  <v-dialog v-model="todosBairrosDialog" :disabled="!disabled" width="1000px" scrollable>
    <template v-slot:activator="{ on }">
      <mf-button text label="Ver todos" :disabled="!disabled" v-on:click.native="on.click" />
    </template>
    <v-card class="todos-bairros-card">
      <v-card-title>
        <span class="pa-2 table-card-title">Todos os bairros</span>
        <v-spacer />
        <span class="caption secondary-text">{{ clientesNaoResolvidos | localeString(0) }} clientes não resolvidos</span>
      </v-card-title>
      <mf-loading :loader="['todos-bairros']" :width="6" :height="130">
        <v-data-table :items="bairrosTodos" :headers="headers" :items-per-page-options="rowsPerPageArray">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item['DES_BAIRRO'] }}</td>
              <td>{{ item['DES_CIDADE_SN'] }}</td>
              <td>{{ item['DES_ESTADO_SN'] }}</td>
              <td>{{ item['DES_PAIS'] }}</td>
              <td class="text-right">
                {{ item['NUM_CLIENTES_CADASTRADOS'] | localeString }}<mf-quick-actions v-if="item.COD_ID_BAIRRO" v-bind="getQuickActionProps(item)" />
              </td>
              <td>
                <v-menu bottom origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
                  </template>

                  <v-list>
                    <v-list-item @click="exportCsv(item)">
                      <v-list-item-title>Exportar .csv</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </v-card>
  </v-dialog>
</template>

<script>
import { orderBy } from 'lodash'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { createCsvFromArray } from '@/config/helpers.js'
import { criteriaGroup, personTypeCriteria, neighborhoodsCriteria } from '@/components/quick-actions/segmentationGroups.js'

export default {
  props: {
    disabled: Boolean,
    tipoPessoa: String,
    clientesNaoResolvidos: Number,
  },
  data: () => ({
    todosBairrosDialog: false,
    bairrosData: null,
  }),
  computed: {
    ...mapState({
      stateInfoBairroFisica: (state) => state.clientes.perfilDemograficoBairroFisica,
      stateInfoBairroJuridica: (state) => state.clientes.perfilDemograficoBairroJuridica,
      stateFilters: (state) => state.filters,
    }),
    infoBairro() {
      const infoBairroArray = this.tipoPessoa === 'F' ? this.stateInfoBairroFisica : this.stateInfoBairroJuridica
      let array = infoBairroArray.map((object) => {
        if (object['DES_BAIRRO'] === '') {
          object['DES_BAIRRO'] = 'NÃO INFORMADO'
        }
        return object
      })
      return orderBy(array, 'NUM_CLIENTES_CADASTRADOS')
    },
    filter() {
      return {
        unidades: this.stateFilters.units,
        tipo_pessoa: this.tipoPessoa,
        categoria_cliente: this.stateFilters.cliente,
        fidelidade: this.stateFilters.fidelidade,
        group_field: 'bairro',
      }
    },
    headers() {
      return [
        {
          text: 'Bairro',
          align: 'left',
          value: 'DES_BAIRRO',
          width: '35%',
        },
        {
          text: 'Cidade',
          value: 'DES_CIDADE_SN',
          width: '20%',
        },
        {
          text: 'Estado',
          value: 'DES_ESTADO_SN',
          width: '10%',
        },
        {
          text: 'Pais',
          value: 'DES_PAIS',
          width: '10%',
        },
        {
          text: 'Clientes',
          align: 'right',
          value: 'NUM_CLIENTES_CADASTRADOS',
          width: '25%',
        },
        {
          text: '',
          sortable: false,
        },
      ]
    },
    bairrosTodos() {
      return orderBy(this.infoBairro, ['NUM_CLIENTES_CADASTRADOS'], ['desc'])
    },
    rowsPerPageArray: () => [10, 15, 25, 50, 100, { text: 'Todos', value: -1 }],
  },
  methods: {
    ...mapWaitingActions({
      listaClientesCadastrados: 'lista-clientes-cadastrados',
    }),
    async exportCsv(bairro) {
      const nomeBairro = bairro['DES_BAIRRO'].toLowerCase().split(' ').join('_')
      const data = await this.listaClientesCadastrados({ tipo_pessoa: this.tipoPessoa, bairro: bairro['COD_ID_BAIRRO'] })
      const arrayToExport = data.map((clients) => ({ id: clients['NUM_CPF_CNPJ'] }))
      createCsvFromArray(arrayToExport, `cadastros_${nomeBairro}`, ['CPF/CNPJ'])
    },
    getQuickActionProps(item) {
      const segmentationGroup = (groupValues) => (quickActionFiltersCriteria) =>
        criteriaGroup([
          personTypeCriteria('F'),
          neighborhoodsCriteria(groupValues),
          ...quickActionFiltersCriteria.criteria.segments,
          ...quickActionFiltersCriteria.criteria.loyalty,
          ...quickActionFiltersCriteria.criteria.clientGroups,
        ])
      return {
        quickActionGroupId: `neighborhood-${item.COD_ID_BAIRRO}`,
        shortDescription: `Clientes do(s) bairro(s)`,
        longDescription: `Clientes do(s) bairro(s)`,
        quickActionGroup: 'neighborhoods',
        quickActionGroupValue: [item.COD_ID_PAIS, item.COD_ID_ESTADO, item.COD_ID_CIDADE, item.COD_ID_BAIRRO],
        segmentationGroup,
      }
    },
  },
}
</script>

<style lang="scss">
.todos-bairros-card {
  min-height: 260px;
}
</style>
